import React from 'react'

import { Spinner, Table } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import s from './s.module.css'
import { useColumns } from './useColumns'
import { tableLang } from '~uikitLang'

interface Props {
    cards?: GetCard[]
    isCardsLoading?: boolean
    selectedCard?: GetCard
    setSelectedCard: (selectedCard: GetCard) => void
}

function List({ cards, isCardsLoading, selectedCard, setSelectedCard }: Props) {
    const columns = useColumns()

    if (isCardsLoading) {
        return (
            <div className={s.spinner}>
                <Spinner intent="accent" size={36} />
            </div>
        )
    }

    return (
        <Table
            columns={columns}
            rowHoverable
            transparent
            rounded={false}
            data={cards || []}
            locales={tableLang}
            dataPointer="card_list_table"
            onRowClick={datum => setSelectedCard(datum)}
            isSelected={datum => selectedCard?.id === datum?.id}
            className={s.table}
        />
    )
}

export { List }
